import { render, staticRenderFns } from "./SegmentFilter.vue?vue&type=template&id=4f57f052&"
import script from "./SegmentFilter.vue?vue&type=script&lang=js&"
export * from "./SegmentFilter.vue?vue&type=script&lang=js&"
import style0 from "./SegmentFilter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports